/* eslint-disable */
// /src/services/taxService.js
// 세무자료 센터용 서비스
// - settlements_raw 컬렉션에서 내 정산 데이터 조회
// - payload.fullRow 안의 엑셀 원본 숫자들을 읽어 월별 합계 계산

import { collection, getDocs, query, where } from "firebase/firestore";
import { db } from "./firebase";

// 안전하게 숫자로 변환 + 원 단위 반올림
function toWon(value) {
    if (value == null || value === "") return 0;
    const n = Number(value);
    if (Number.isNaN(n)) return 0;
    return Math.round(n);
}

// 1~12월 기본 버킷
function makeEmptyMonthRows() {
    return Array.from({ length: 12 }, (_, idx) => ({
        month: idx + 1,
        totalFare: 0, // 월 총 운임
        fee: 0,       // 계속가맹금
        service: 0,   // 부가서비스
    }));
}

/**
 * 내 세무자료 요약 가져오기
 * @param {Object} params
 * @param {number} params.year          예: 2025
 * @param {string} params.franchiseName settlements_raw."가맹점(운수사명)" 값
 * @param {string} [params.settlementType="personal"] personal | corporate 등
 */
export async function fetchMyTaxSummary({
    year,
    franchiseName,
    settlementType = "personal",
}) {
    const monthRows = makeEmptyMonthRows();

    if (!year || !franchiseName) {
        console.warn("[taxService] year 또는 franchiseName 이 비어 있음", {
            year,
            franchiseName,
        });
        return {
            monthRows,
            annual: { totalFare: 0, fee: 0, service: 0 },
        };
    }

    try {
        const colRef = collection(db, "settlements_raw");

        const q = query(
            colRef,
            where("__settlementYear", "==", String(year)),
            where("__settlementType", "==", settlementType),
            where("가맹점(운수사명)", "==", franchiseName)
        );

        const snap = await getDocs(q);

        snap.forEach((doc) => {
            const data = doc.data() || {};
            const full = data.payload?.fullRow || {};

            // 월 정보 ("06" → 6)
            const mStr = data.__settlementMonth || data["__settlementMonth"];
            const month = Number(mStr);
            if (!month || month < 1 || month > 12) return;

            const bucket = monthRows[month - 1];

            // 🔹 엑셀 컬럼 이름에 맞게 키 지정
            // 1) 총 운임
            const totalFareRaw =
                full["1) 총 운임"] ??
                full["총 운임"] ??
                full["총운임"] ??
                full["1)총 운임"];

            // 2) 계속가맹금 (운임*요율)
            const feeRaw = full["운임*요율"];

            // 3) 부가서비스(VAT포함)
            const serviceRaw =
                full["부가서비스(VAT포함)"] ??
                full["부가서비스 (VAT포함)"] ??
                full["부가서비스"];

            bucket.totalFare += toWon(totalFareRaw);
            bucket.fee += toWon(feeRaw);
            bucket.service += toWon(serviceRaw);
        });

        const annual = monthRows.reduce(
            (acc, r) => {
                acc.totalFare += r.totalFare;
                acc.fee += r.fee;
                acc.service += r.service;
                return acc;
            },
            { totalFare: 0, fee: 0, service: 0 }
        );

        return { monthRows, annual };
    } catch (e) {
        console.error("[taxService] fetchMyTaxSummary error", e);
        return {
            monthRows,
            annual: { totalFare: 0, fee: 0, service: 0 },
        };
    }
}





export async function fetchMyTaxSummaryOptimized({
    year,
    franchiseName,
    settlementType = "personal",
}) {


    console.log("year, franchiseName", year, franchiseName);

    if (!year || !franchiseName) {
        return { monthRows: [], annual: { totalFare: 0, fee: 0, service: 0 } };
    }

    const col = collection(db, "settlements_raw");
    const monthRows = Array.from({ length: 12 }, (_, i) => ({
        month: i + 1,
        totalFare: 0,
        fee: 0,
        service: 0,
    }));

    for (let m = 1; m <= 12; m += 1) {
        const monthKey = `${year}-${String(m).padStart(2, "0")}`;

        const qy = query(
            col,
            where("settlementMonthKey", "==", monthKey),
            where("settlementType", "==", settlementType),
            where("payload.franchiseName", "==", franchiseName)
        );

        try {
            const snap = await getDocs(qy);

            snap.docs.forEach((docSnap, idx) => {
                try {
                    const d = docSnap.data() || {};

                    console.log("d", d);
                    const full = d?.payload?.fullRow || {};

                    console.log("full datat", full);

                    const totalFareRaw =
                        full["총운임(vat포함)"] ?? 0;

                    const feeRaw = full["운임*요율"] ?? 0;
                    const serviceRaw =
                        full["분배액"] ?? 0;

                    monthRows[m - 1].totalFare += toWon(totalFareRaw);
                    monthRows[m - 1].fee += toWon(feeRaw);
                    monthRows[m - 1].service += toWon(serviceRaw);
                } catch (eDoc) {
                    console.error(
                        "[taxService] doc error",
                        {
                            monthKey,
                            monthIndex: m,
                            docIndex: idx,
                            docId: docSnap.id,
                        },
                        eDoc
                    );
                }
            });
        } catch (e) {
            console.error(
                "[taxService] month error",
                {
                    year,
                    monthKey,
                    monthIndex: m,
                    franchiseName,
                    settlementType,
                },
                e
            );
        }
    }

    // 연간 합계 자동 계산
    const annual = monthRows.reduce(
        (acc, r) => {
            acc.totalFare += r.totalFare;
            acc.fee += r.fee;
            acc.service += r.service;
            return acc;
        },
        { totalFare: 0, fee: 0, service: 0 }
    );

    return { monthRows, annual };
}
